import { trackFirebaseEvent } from "./analytics";
import { FIREBASE_EVENT_NAME, type FirebaseHeartbeatState } from "./types";

/** 依頼書 §7: 60秒固定。30秒や120秒に変えない */
const HEARTBEAT_INTERVAL_MS = 60_000;

/** heartbeat を送れるのは4状態のみ。状態ごとに付与するIDが型で強制される */
export type FirebaseHeartbeatTarget =
  | { state: "calling"; callId: string }
  | { state: "broadcasting" | "viewing"; broadcastId: string }
  | { state: "waiting" };

const timers = new Map<
  FirebaseHeartbeatState,
  ReturnType<typeof setInterval>
>();

const sendHeartbeat = (target: FirebaseHeartbeatTarget): void => {
  if (target.state === "waiting") {
    trackFirebaseEvent(FIREBASE_EVENT_NAME.STATE_HEARTBEAT, {
      state: "waiting",
    });
    return;
  }
  if (target.state === "calling") {
    trackFirebaseEvent(FIREBASE_EVENT_NAME.STATE_HEARTBEAT, {
      state: "calling",
      call_id: target.callId,
    });
    return;
  }
  trackFirebaseEvent(FIREBASE_EVENT_NAME.STATE_HEARTBEAT, {
    state: target.state,
    broadcast_id: target.broadcastId,
  });
};

/**
 * 対象状態にいる間、60秒ごとに state_heartbeat を送るタイマーを開始する。
 * 同じ状態のタイマーが既にあれば置き換える。初回送信は開始から60秒後。
 */
export const startFirebaseHeartbeat = (
  target: FirebaseHeartbeatTarget,
): void => {
  stopFirebaseHeartbeat(target.state);
  timers.set(
    target.state,
    setInterval(() => sendHeartbeat(target), HEARTBEAT_INTERVAL_MS),
  );
};

/** 対象状態の heartbeat タイマーを停止する（未開始なら何もしない） */
export const stopFirebaseHeartbeat = (state: FirebaseHeartbeatState): void => {
  const timer = timers.get(state);
  if (timer === undefined) return;
  clearInterval(timer);
  timers.delete(state);
};

/** テスト用: 全タイマーを停止する */
export const stopAllFirebaseHeartbeats = (): void => {
  for (const state of [...timers.keys()]) {
    stopFirebaseHeartbeat(state);
  }
};
